import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccountPostingType from './account-posting-type.reducer';

export const selectAccountPostingTypeState = createFeatureSelector<
    fromAccountPostingType.State
>(fromAccountPostingType.accountPostingTypesFeatureKey);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromAccountPostingType.adapter.getSelectors(selectAccountPostingTypeState);
